"use client";

import React from "react";
import styles from "./Shimmer.module.scss";

interface ShimmerItemProps {
  height?: string | number;
  width?: string | number;
  rounded?: boolean | string; // true → pill, false → square, or pass "lg"/"sm"/"circle"
  className?: string;
  align?: "start" | "center" | "end" | "stretch"; // 👈 new prop
}

export default function ShimmerItem({
  height = "100px",
  width = "100%",
  rounded = false,
  className = "",
  align = "start",
}: ShimmerItemProps) {
  const style: React.CSSProperties = {
    height,
    width,
    alignSelf:
      align === "start"
        ? "flex-start"
        : align === "center"
        ? "center"
        : align === "end"
        ? "flex-end"
        : "stretch",
  };

  let roundedClass = "";
  if (rounded === true) roundedClass = "rounded-pill"; // bootstrap pill
  else if (typeof rounded === "string") roundedClass = `rounded-${rounded}`; // e.g. rounded-lg, rounded-circle
  else if (rounded === false) roundedClass = ""; // square

  return (
    <div
      className={`${styles.shimmer} ${roundedClass} ${className}`}
      style={style}
    />
  );
}
